/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { Badge } from "reactstrap";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const classes = useStyles();
  const { tableHead, tableData, tableHeaderColor, tableSelect } = props;
  const [selected, setSelected] = useState([]);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
    handleChange(newSelected);
  };

  function handleChange(e) {
    props.select(e);
  }

  function tags(e) {
    return e[e.length - 1];
  }

  useEffect(() => {
    var list = [];
    if (tableSelect !== undefined && tableSelect.length > 0) {
      tableSelect.forEach(e => {
        if (e.dataId === undefined) {
          list = list.concat(e);
        } else {
          list = list.concat(e.dataId);
        }
      });
    }
    setSelected(list);
  }, [tableSelect]);

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.slice().map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer" }}
                selected={true}
                hover={true}
                role="checkbox"
                onClick={event => {
                  if (tableData[key1][8] !== undefined) {
                    handleClick(event, tableData[key1][8]);
                  } else {
                    handleClick(event, tableData[key1][1]);
                  }
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selected.some(a =>
                      tableData[key1][8] !== undefined
                        ? a === tableData[key1][8]
                        : a === tableData[key1][1]
                    )}
                  />
                </TableCell>
                {tableData[key1][8] !== undefined
                  ? prop.slice(0, 8).map((prop, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>
                            {prop}
                            {"   "}
                            {key === 0 ? (
                              <Badge color="secondary">
                                {tags(tableData[key1])}
                              </Badge>
                            ) : (
                              ""
                            )}
                          </h6>
                        </TableCell>
                      );
                    })
                  : prop.slice(0, 1).map((prop, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>{prop}</h6>
                        </TableCell>
                      );
                    })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  tableSelect: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
